import { Component, inject, OnInit } from '@angular/core'
import { TranslocoService } from '@jsverse/transloco'

@Component({
  selector: 'app-transloco-root',
  template: '<ng-content></ng-content>',
  standalone: true,
  imports: [],
})
export class TranslocoRootComponent implements OnInit {
  private translocoService = inject(TranslocoService)

  ngOnInit() {
    // Set default language to Czech
    this.translocoService.setDefaultLang('cs')
    this.translocoService.setActiveLang('cs')
  }
}
